namespace Ir.Components.Workbook.Settings.Items.FieldMetricSetting {
    export interface IFieldMetricSettingParams {
        id: KnockoutObservable<number>;
        autoGrouping?: KnockoutObservable<AutoGroupingEnum>;
        label: string | KnockoutObservable<string>;
        tooltip?: string;
        type: MappingPopoverTypeEnum;
        valueChangeType?: FieldMetricSettingsValueChangeTypeEnum;
        disabled?: KnockoutObservable<boolean> | KnockoutComputed<boolean>;
        onFiltering?: (items: Array<any>) => Array<any>
        onSelected?(newValue: FieldNameInputModel, oldValue: FieldNameInputModel);
        onClear?(oldValue: FieldNameInputModel);
    }

    interface IViewModel {
        textBoxOptions: DevExpress.ui.dxTextBox.Properties;
        popoverButtonOptions: DevExpress.ui.dxButton.Properties;
        removeButtonOptions: DevExpress.ui.dxButton.Properties;
        label: any;
        tooltip: string;
    }

    interface IParams {
        config: IFieldMetricSettingParams;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;
        self.label = params.config.label;
        self.tooltip = params.config.tooltip;
        if (params.config.valueChangeType === undefined) {
            params.config.valueChangeType = FieldMetricSettingsValueChangeTypeEnum.Before;
        }

        let metricOrField = ko.computed(function (this: KnockoutObservable<number>) {
            let id = this();
            let metricOrField: FieldNameInputModel = null;
            if (id !== 0) {
                if (params.config.type === MappingPopoverTypeEnum.Metrics) {
                    metricOrField = MappingService.getMetricFieldModel(id);
                }
                else {
                    metricOrField = MappingService.getField(id);
                }
            }
            return metricOrField;
        }, params.config.id);

        let name = ko.computed(function (this: KnockoutObservable<number>) {
            let metricOrFieldValue = metricOrField();
            let nameValue = "";
            if (metricOrFieldValue) {
                nameValue = metricOrFieldValue.displayName || metricOrFieldValue.nodeName;
                if (params.config.type !== MappingPopoverTypeEnum.Metrics && params.config.autoGrouping) {
                    let autoGrouping = params.config.autoGrouping();
                    let autoGroupingText = autoGrouping !== AutoGroupingEnum.None ? " " + autoGroupingToStringAndSplit(autoGrouping) : "";
                    nameValue += autoGroupingText;
                }
            }
            return replaceBasicHtmlContent(nameValue);
        });

        let $textbox;
        self.textBoxOptions = {
            value: name as any,
            width: "100%",
            readOnly: true,
            hint: self.tooltip,
            onInitialized(e) {
                $textbox = e.element;
            }
        };

        self.popoverButtonOptions = {
            icon: "ms ir-find-icon",
            hint: ko.computed(function () {
                return "Choose the " + getLabel(params.config);
            }) as any,
            disabled: params.config.disabled ?? false as any,
            onClick: function (e) {
                let onSelected = function (item: FieldNameInputModel) {
                    let oldMetricOrField = metricOrField();
                    if (params.config.valueChangeType === FieldMetricSettingsValueChangeTypeEnum.Before) {
                        if (params.config.onSelected) {
                            params.config.onSelected(item, oldMetricOrField);
                        }
                    }

                    if (params.config.type === MappingPopoverTypeEnum.Metrics) {
                        params.config.id(item.metricId);
                    }
                    else {
                        if (params.config.autoGrouping) {
                            params.config.autoGrouping(item.autoGrouping);
                        }

                        params.config.id(item.fieldId);
                    }

                    if (params.config.valueChangeType === FieldMetricSettingsValueChangeTypeEnum.After) {
                        if (params.config.onSelected) {
                            params.config.onSelected(item, oldMetricOrField);
                        }
                    }
                };

                MappingService.show({
                    type: params.config.type,
                    $target: $textbox,
                    onSelect: onSelected,
                    onFiltering: params.config.onFiltering
                });
            }
        };

        self.removeButtonOptions = {
            icon: "ms ir-clear-icon",
            hint: ko.computed(function () {
                return "Remove the " + getLabel(params.config);
            }) as any,
            disabled: params.config.disabled ?? false as any,
            onClick: function (e) {
                if (params.config.valueChangeType === FieldMetricSettingsValueChangeTypeEnum.Before) {
                    if(params.config.onClear) {
                        params.config.onClear(metricOrField());
                    }
                }

                params.config.id(null);

                if (params.config.valueChangeType === FieldMetricSettingsValueChangeTypeEnum.After) {
                    if(params.config.onClear) {
                        params.config.onClear(metricOrField());
                    }
                }
            }
        };
    }

    function getLabel(config: IFieldMetricSettingParams) {
        return typeof config.label === "function" ? config.label() : config.label;
    }
}